import { render, staticRenderFns } from "./extra-mein-profil.vue?vue&type=template&id=968f8448&lang=pug&"
import script from "./extra-mein-profil.vue?vue&type=script&lang=js&"
export * from "./extra-mein-profil.vue?vue&type=script&lang=js&"
import style0 from "./extra-mein-profil.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports